import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { addAccount } from "../../store/accountThunk";
import { switchAccount } from '../../store/authSlice';

import CustomDialog from "../../components/Dialog/Dialog";

/**
 * Account Form Component.
 */
const AccountForm: FC = () => {
  const [open, setOpen] = useState(false);
  const { user} = useAppSelector(state => state.auth);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  /**
   * Method to handle account form submit.
   */
  const onSubmit = async (data: any) => {
    // Dispatch add account action.
    try {
      dispatch(addAccount(data)).unwrap().then((data) => {
        if(data.account) {
          dispatch(switchAccount({ accountId: data.account._id, userId: user._id })).then((switchData) => {
            if(switchData) {
              navigate("/home");
            }
          }).catch(e => {
            //console.log(e);
          });
        }
      }).catch(e => {
        //console.log(e);
      });

      //navigate("/home");
    } catch (error: any) {
      // Empty catch block.
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

   /**
   * Open modal
   */
  useEffect(() => {
    handleOpen();
  }, []);

  return (
    <CustomDialog title='Create Account' open={open} onClose={handleClose} onSubmit={onSubmit} />
  );
};

export default AccountForm;
